var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankCardNavy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56518 0C1.59806 0 0 1.58885 0 3.54462V6.20308H37.4344V3.54462C37.4344 1.58885 35.8363 0 33.8692 0H3.56518ZM0 10.6338V23.04C0 24.9958 1.59806 26.5846 3.56518 26.5846H33.8692C35.8363 26.5846 37.4344 24.9958 37.4344 23.04V10.6338H0ZM6.23906 13.2923H20.4998V15.0646H6.23906V13.2923ZM39.2169 16.8923V23.04C39.2169 25.9719 36.8181 28.3569 33.8692 28.3569H3.56518C3.45725 28.3569 3.33887 28.3362 3.23094 28.3292L4.09438 33.0646C4.2615 33.9992 4.76285 34.8231 5.54274 35.3631C6.14854 35.7854 6.85182 36 7.576 36C7.7849 36 8.00772 35.9827 8.21662 35.9446L38.0471 30.6554C38.9837 30.4892 39.8158 29.9631 40.3589 29.1877C40.902 28.4123 41.1109 27.4881 40.9438 26.5569L39.2169 16.8923Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardNavy);
export default __webpack_public_path__ + "static/media/bank-card-navy.3583c33f308ec4859ee86a76e8d286e1.svg";
export { ForwardRef as ReactComponent };